import { linkToClassPage } from "../../links";

export function linkToClassStudentsPage(classId?: string) {
  return `${linkToClassPage(classId)}/students`;
}
